import { useReveal } from "@/hooks/useReveal";
import { LayoutGrid, Wand2, Gift, ShoppingBag, CalendarCheck, Star, Cake, MessageCircle } from "lucide-react";

const FEATURES = [
  { icon: LayoutGrid, title: "Полный каталог" },
  { icon: Wand2, title: "ИИ-примерка" },
  { icon: Gift, title: "Бонусный счёт" },
  { icon: ShoppingBag, title: "Новые коллекции" },
  { icon: CalendarCheck, title: "Запись на примерку" },
  { icon: Star, title: "История бонусов" },
  { icon: Cake, title: "Подарки ко Дню рождения" },
  { icon: MessageCircle, title: "Быстрая связь с консультантом" },
];

export const Features = () => {
  const ref = useReveal();
  return (
    <section id="features" ref={ref} data-testid="features-section" className="py-28 md:py-36" style={{ background: "var(--ink)" }}>
      <div className="pw-container">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="reveal order-2 lg:order-1 flex justify-center">
            <img
              src="/media/phone-front.png"
              alt="Angiolini VIP на iPhone 17"
              loading="lazy"
              data-testid="phone-static"
              className="w-full max-w-[300px]"
              style={{ filter: "drop-shadow(0 28px 56px rgba(0,0,0,0.55))" }}
            />
          </div>

          <div className="order-1 lg:order-2">
            <span className="pw-eyebrow reveal !text-white/50">Закрытый доступ</span>
            <h2 className="pw-h2 reveal mt-6 !text-white">
              Все возможности Angiolini — в одном пространстве.
            </h2>
            <p className="reveal mt-6 text-white/55 text-base leading-relaxed max-w-md">
              Никаких переписок, долгих ожиданий или поиска информации. Всё уже
              собрано в вашем личном кабинете.
            </p>
            <div className="grid sm:grid-cols-2 gap-3 mt-10">
              {FEATURES.map((f, i) => (
                <div
                  key={i}
                  data-testid={`feature-item-${i}`}
                  className="reveal flex items-center gap-4 p-4 rounded-xl border transition-colors duration-300 hover:border-white/35"
                  style={{
                    background: "rgba(255,255,255,0.04)",
                    borderColor: "rgba(255,255,255,0.1)",
                    transitionDelay: `${i * 60}ms`,
                  }}
                >
                  <f.icon size={18} strokeWidth={1.5} style={{ color: "var(--accent)" }} className="shrink-0" />
                  <span className="text-[14px] font-medium text-white/85">{f.title}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
